import BigNumber from 'bignumber.js';

export function formatPrice(value: number): string {
  return value ? new BigNumber(value)?.toFixed(2) : '';
}

export function priceAdd (total: number, num: number) {
  return new BigNumber(total).plus(num).toFixed(2);
}

// 减
export function priceSubtraction (total: number, num: number) {
  return Number(new BigNumber(total).minus(num).toFixed(2))
}

// 乘积
export function priceMultiply (total: number, num: number) {
  return new BigNumber(total).times(num).toFixed(2);
}

// 除
export function priceDivide (total: number, num: number) {
  return new BigNumber(total).dividedBy(num).toFixed(2)
}

export function toFixed (num: number, decimalPlaces = 2) {
  return new BigNumber(num).toFixed(decimalPlaces);
}

export function truncateToTwoDecimals(value: number) {
  // 确保输入是一个 BigNumber 实例
  const num = new BigNumber(value);
  
  // 设置小数位数为 2 并使用 ROUND_DOWN 模式进行舍弃
  return num.decimalPlaces(2, BigNumber.ROUND_DOWN);
}